import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext'; 

const ProtectedRoute = ({ children, allowedRoles }) => {
  // 1. نستخرج token أيضاً لمعرفة النية المسبقة لتسجيل الدخول
  const { user, token } = useAuth();

  // 2. حالة "قيد الاستعادة": يوجد توكن أمني، لكن كائن المستخدم لم يُبنى بعد (تحدث عند تحديث الصفحة)
  if (token && !user) {
    // إرجاع واجهة تحميل صامتة تمنع الطرد المبكر حتى يكتمل بناء الجلسة
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <span className="text-slate-400 font-bold text-sm">جاري مصادقة الجلسة...</span>
      </div>
    );
  }

  // 3. إذا لم يكن هناك توكن أصلاً (مستخدم غير مسجل الدخول نهائياً)
  if (!token && !user) {
    return <Navigate to="/login" replace />;
  }

  // 4. حماية الصلاحيات (Role-Based Access) بعد اكتمال تحميل كائن المستخدم
  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // توجيهه إلى مساحته الخاصة حسب دوره لمنع التطفل
    if (user.role === 'admin') return <Navigate to="/admin" replace />;
    if (user.role === 'educator') return <Navigate to="/workshop" replace />;
    
    return <Navigate to="/" replace />;
  }

  // 5. الجلسة سليمة والصلاحية متطابقة: اسمح له بالمرور
  return children;
};

export default ProtectedRoute;